import React, { useState } from 'react';
import './AddUnitModal.styles.css';
import apiService from '../../services/api';

const AddUnitModal = ({ isOpen, onClose, onSave }) => {
  const [unitData, setUnitData] = useState({
    name: '',
    shortName: '',
    allowDecimal: false
  });
  const [isSaving, setIsSaving] = useState(false);
  const [apiError, setApiError] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setUnitData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!unitData.name.trim() || !unitData.shortName.trim()) {
      alert('Please fill in all required fields');
      return;
    }

    setIsSaving(true);
    setApiError(null);

    try {
      const payload = {
        actual_name: unitData.name.trim(),
        short_name: unitData.shortName.trim(),
        allow_decimal: unitData.allowDecimal
      };

      const res = await apiService.createUnit(payload);
      const createdUnit = res.data || res;

      if (onSave) {
        onSave(createdUnit);
      }

      setUnitData({ name: '', shortName: '', allowDecimal: false });
      setApiError(null);
      onClose();
    } catch (err) {
      setApiError('Failed to create unit: ' + err.message);
    } finally {
      setIsSaving(false);
    }
  };

  const handleClose = () => {
    setUnitData({ name: '', shortName: '', allowDecimal: false });
    setApiError(null);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay add-unit-overlay" onClick={handleClose}>
      <div className="modal-content add-unit-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Add Unit</h2>
          <button className="modal-close" onClick={handleClose}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          {apiError && (
            <div style={{
              marginBottom: '1rem',
              padding: '0.6rem 0.9rem',
              background: '#fef2f2',
              border: '1px solid #fecaca',
              borderRadius: '6px',
              color: '#991b1b',
              fontSize: '0.85rem'
            }}>
              {apiError}
            </div>
          )}

          <div className="form-group">
            <label>Name:*</label>
            <input
              type="text"
              name="name"
              value={unitData.name}
              onChange={handleChange}
              placeholder="Name"
              required
            />
          </div>

          <div className="form-group">
            <label>Short name:*</label>
            <input
              type="text"
              name="shortName"
              value={unitData.shortName}
              onChange={handleChange}
              placeholder="Short name"
              required
            />
          </div>

          <div className="form-group">
            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <input
                type="checkbox"
                name="allowDecimal"
                checked={unitData.allowDecimal}
                onChange={handleChange}
                style={{ marginRight: '8px', width: 'auto', height: 'auto' }}
              />
              Allow decimal:*
            </label>
          </div>

          <div className="modal-actions">
            <button type="button" className="btn-cancel" onClick={handleClose} disabled={isSaving}>
              Cancel
            </button>
            <button
              type="submit"
              className="btn-save"
              disabled={isSaving}
              style={{ opacity: isSaving ? 0.7 : 1, cursor: isSaving ? 'not-allowed' : 'pointer' }}
            >
              {isSaving ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddUnitModal;
